import { Star } from "lucide-react";
import { ALL_TESTIMONIALS, shortName } from "@/data/testimonials";

const PICKS = ALL_TESTIMONIALS.filter((t) => t.quote.length <= 220).slice(0, 10);

const shortRole = (role) => (role.split(" | ")[0] || "").trim();

function Strip({ hidden }) {
  return (
    <div className="flex shrink-0 items-stretch" aria-hidden={hidden || undefined}>
      {PICKS.map((t) => (
        <figure
          key={t.name + t.quote.slice(0, 24)}
          className="mx-2 flex w-80 shrink-0 flex-col gap-4 rounded-2xl border border-slate-200 bg-white shadow-sm p-5 sm:w-96 sm:p-6"
        >
          <Star className="h-3.5 w-3.5 shrink-0 text-flame" fill="currentColor" aria-hidden="true" />
          <blockquote className="text-base leading-relaxed text-slate-800">
            &ldquo;{t.quote}&rdquo;
          </blockquote>
          <figcaption className="mt-auto">
            <div className="font-mono text-base font-semibold uppercase tracking-[0.2em] text-flame">
              {shortName(t.name)}
            </div>
            <div className="mt-1 line-clamp-1 text-base text-slate-700">{shortRole(t.role)}</div>
          </figcaption>
        </figure>
      ))}
    </div>
  );
}

export default function TrustMarquee() {
  return (
    <section
      data-testid="trust-marquee"
      className="relative border-y border-slate-200 py-8"
    >
      <div className="relative overflow-hidden">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-obsidian to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-obsidian to-transparent" />
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused] motion-reduce:animate-none">
          <Strip />
          <Strip hidden />
        </div>
      </div>
      <div
        data-testid="trust-marquee-badge"
        className="pointer-events-none absolute left-1/2 top-0 z-20 flex -translate-x-1/2 -translate-y-1/2 items-center gap-2 whitespace-nowrap rounded-full border border-flame/30 bg-flame/10 px-4 py-1.5 font-mono text-[13px] uppercase tracking-[0.2em] text-flame backdrop-blur-sm"
      >
        <span className="h-1.5 w-1.5 rounded-full bg-flame" />
        97 recommendations · since 2007
      </div>
    </section>
  );
}
